module.exports = __webpack_public_path__ + "static/Touchless_MonthTwo-33-527074a2b09bead3808dd4c4a3fd9aa6.jpg";